import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgProduct extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg viewBox="0 0 250 236.79" height={size}>
                <g>
                    <path
                        d="M26.86,89.56,155.94,31.87a3,3,0,0,1,2.61.06L273.25,89.51a3,3,0,0,1-.12,5.5L153.68,148.69a3,3,0,0,1-2.45,0L26.89,95.14A3,3,0,0,1,26.86,89.56Z"
                        transform="translate(-25 -31.6)"
                        fill={color}
                    />
                    <path
                        d="M273.23,152.08a3,3,0,0,1-.09,5.5C252.41,167,182.25,198.71,154.85,211a6.13,6.13,0,0,1-4.4.27c-35.78-15.46-102.68-44.6-123.52-53.68a3,3,0,0,1,0-5.58l37.55-16.6a3,3,0,0,1,2.42,0c8.4,3.57,58.41,24.84,83.28,35.71a4.9,4.9,0,0,0,4.44,0c24.37-11.07,72.77-32.5,81.3-36.27a3,3,0,0,1,2.58.06Z"
                        transform="translate(-25 -31.6)"
                        fill={color}
                    />
                    <path
                        d="M26.82,208.53l37.74-16.6a3,3,0,0,1,2.42,0c8.36,3.57,58,24.76,82.93,35.66a5.43,5.43,0,0,0,5-.05c26.7-12.14,81.75-36.91,82.49-36.88.58,0,24.73,12.15,36,17.84a3,3,0,0,1-.11,5.49c-19.54,8.91-84.17,38.23-118.65,53.85a4.6,4.6,0,0,1-4.19.15L26.83,214.11A3,3,0,0,1,26.82,208.53Z"
                        transform="translate(-25 -31.6)"
                        fill={color}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgProduct);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgProduct.js